export default Object.freeze({
  Stdio: 1,
  Http: 2,
});
